import * as types from '../mutation-types'

// initial state
const state = {
  menu: null,
  list: null
}

// mutations
const mutations = {
  [types.SLIDE_LIST] (state, action) {
    state.menu = action.data.menu
    state.list = action.data.slides
  }
}

export default {
  state,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/slide.js